/**
 * Created by iamso on 05.11.2020.
 */

const ScrollBarHandler = function (scroll, options) {
    this.scroll = scroll;
    this.options = options || {};
};

ScrollBarHandler.prototype.reset = function () {
    const barXVisible = (this.scroll.direction & cleverapps.UI.ScrollView.DIR_HORIZONTAL) && this.scroll.min.x !== this.scroll.max.x;
    const barYVisible = (this.scroll.direction & cleverapps.UI.ScrollView.DIR_VERTICAL) && this.scroll.min.y !== this.scroll.max.y;
    if (!this.barY && barYVisible) {
        this.barY = new ScrollBar(this.scroll, cleverapps.UI.ScrollView.DIR_VERTICAL, this.options);
    }
    if (!this.barX && barXVisible) {
        this.barX = new ScrollBar(this.scroll, cleverapps.UI.ScrollView.DIR_HORIZONTAL, this.options);
    }

    if (this.barX) {
        this.barX.setVisible(barXVisible);
    }
    if (this.barY) {
        this.barY.setVisible(barYVisible);
    }

    this.updatePos();
};

ScrollBarHandler.prototype.setAutoHide = function (enable) {
    if (this.barX) {
        this.barX.setAutoHideEnabled(enable);
    }
    if (this.barY) {
        this.barY.setAutoHideEnabled(enable);
    }
};

ScrollBarHandler.prototype.setPadding = function (padding) {
    this.barPadding = padding;
    if (this.barX) {
        this.barX.setPadding(this.barPadding);
    }
    if (this.barY) {
        this.barY.setPadding(this.barPadding);
    }
};

ScrollBarHandler.prototype.updatePos = function () {
    const outOfBoundary = this.scroll.scrollHandler.getHowMuchOutOfBoundary();
    if (this.barY) {
        this.barY.onScrolled(outOfBoundary);
    }
    if (this.barX) {
        this.barX.onScrolled(outOfBoundary);
    }
};

ScrollBarHandler.prototype.onTouchBegan = function () {
    if (this.barY) {
        this.barY.onTouchBegan();
    }
    if (this.barX) {
        this.barX.onTouchBegan();
    }
};

ScrollBarHandler.prototype.onTouchEnded = function () {
    if (this.barY) {
        this.barY.onTouchEnded();
    }
    if (this.barX) {
        this.barX.onTouchEnded();
    }
};

const ScrollBar = cc.Node.extend({
    ctor: function (scroll, dir, options) {
        this._super();

        this.scroll = scroll;
        this.dir = dir;
        this.options = options || {};

        this._touching = false;
        this._autoHideRemainingTime = 0;
        this._marginFromBoundary = ScrollBar.DEFAULT_MARGIN;
        this._marginForLength = ScrollBar.DEFAULT_MARGIN;
        this.opacity = this.options.opacity === undefined ? 255 * ScrollBar.DEFAULT_SCROLLBAR_OPACITY : this.options.opacity;
        this.autoHideTime = ScrollBar.DEFAULT_AUTO_HIDE_TIME;
        this._autoHideEnabled = true;

        this.init();

        this.setCascadeColorEnabled(true);
        this.setCascadeOpacityEnabled(true);

        scroll.barContainer.addChild(this);

        this.setAutoHideEnabled(false);

        this.setPadding(this.scroll.barHandler.barPadding);
        this.addControls();
        this.setWidth(this.options.width || cleverapps.styles.ScrollBar.barWidth);
    },

    init: function () {
        this.bar = new cc.Scale9Sprite(this.options.image || bundles.scrollbar.frames.scrollbar_png);
        this.bar.setAnchorPoint(0.5, 0);
        this.addChild(this.bar);

        if (!this.options.skipColor) {
            this.setColor(ScrollBar.DEFAULT_COLOR);
        }
        cc.Node.prototype.setOpacity.call(this, this.options.opacity || 0);
        this.onScrolled(cc.p(0, 0));
        this._autoHideRemainingTime = 0;

        if (this.dir === cleverapps.UI.ScrollView.DIR_HORIZONTAL) {
            this.setRotation(90);
        }
    },

    setPositionFromCorner: function (positionFromCorner) {
        if (this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL) {
            this._marginForLength = positionFromCorner.y;
            this._marginFromBoundary = positionFromCorner.x;
        } else {
            this._marginForLength = positionFromCorner.x;
            this._marginFromBoundary = positionFromCorner.y;
        }
    },

    onEnter: function () {
        cc.Node.prototype.onEnter.call(this);
        this.scheduleUpdate();
    },

    getPositionFromCorner: function () {
        if (this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL) {
            return cc.p(this._marginFromBoundary, this._marginForLength);
        }
        
        return cc.p(this._marginForLength, this._marginFromBoundary);
    },

    setWidth: function (width) {
        this.bar.width = width;
    },

    setAutoHideEnabled: function (autoHideEnabled) {
        this._autoHideEnabled = autoHideEnabled;

        if (!this._autoHideEnabled && !this._touching && this._autoHideRemainingTime <= 0) {
            cc.Node.prototype.setOpacity.call(this, this.opacity);
        } else {
            cc.Node.prototype.setOpacity.call(this, 0);
        }
    },

    isAutoHideEnabled: function () {
        return this._autoHideEnabled;
    },

    setOpacity: function (opacity) {
        this._opacity = opacity;
    },

    getOpacity: function () {
        return this._opacity;
    },

    _updateLength: function (length) {
        this.bar.height = length;
    },

    _processAutoHide: function (dt) {
        if (!this._autoHideEnabled || this._autoHideRemainingTime <= 0) {
            return;
        }
        if (this._touching) {
            // If it is touching, don't auto hide.
            return;
        }

        this._autoHideRemainingTime -= dt;
        if (this._autoHideRemainingTime <= this.autoHideTime) {
            this._autoHideRemainingTime = Math.max(0, this._autoHideRemainingTime);
            cc.Node.prototype.setOpacity.call(this, this._opacity * (this._autoHideRemainingTime / this.autoHideTime));
        }
    },

    update: function (dt) {
        this._processAutoHide(dt);
    },

    onTouchBegan: function () {
        if (!this._autoHideEnabled) {
            return;
        }
        this._touching = true;
    },

    onTouchEnded: function () {
        if (!this._autoHideEnabled) {
            return;
        }
        this._touching = false;

        if (this._autoHideRemainingTime <= 0) {
            // If the remaining time is 0, it means that it didn't moved after touch started so scroll bar is not showing.
            return;
        }
        this._autoHideRemainingTime = this.autoHideTime;
    },

    _calculateLength: function (innerContainerMeasure, scrollViewMeasure, outOfBoundaryValue) {
        let denominatorValue = innerContainerMeasure;
        if (outOfBoundaryValue !== 0) {
            // If it is out of boundary, the length of scroll bar gets shorter quickly.
            const GETTING_SHORTER_FACTOR = 20;
            denominatorValue += (outOfBoundaryValue > 0 ? outOfBoundaryValue : -outOfBoundaryValue) * GETTING_SHORTER_FACTOR;
        }

        const lengthRatio = scrollViewMeasure / denominatorValue;
        return Math.abs(scrollViewMeasure - 2 * this._marginForLength) * lengthRatio;
    },

    // scrollRange is the scroll's max - min, so the bar maps back to the exact percent scrollToPercent set.
    _calculatePosition: function (scrollRange, scrollViewMeasure, innerContainerPosition, outOfBoundaryValue, length) {
        let denominatorValue = scrollRange;
        if (outOfBoundaryValue !== 0) {
            denominatorValue += Math.abs(outOfBoundaryValue);
        }

        let positionRatio = 0;

        if (denominatorValue !== 0) {
            positionRatio = innerContainerPosition / denominatorValue;
            positionRatio = Math.max(positionRatio, 0);
            positionRatio = Math.min(positionRatio, 1);
        }

        const position = (scrollViewMeasure - length - 2 * this._marginForLength) * positionRatio + this._marginForLength;

        if (this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL) {
            return cc.p(this.scroll.width - this._marginFromBoundary, position);
        }
        
        return cc.p(position, this._marginFromBoundary);
    },

    setPadding: function (data) {
        data = data || {};
        const styles = cleverapps.styles.ScrollBar;

        const cornerPadding = data.cornerPadding !== undefined ? data.cornerPadding : styles.cornerPadding;
        const sidePadding = data.sidePadding !== undefined ? data.sidePadding : styles.sidePadding;

        const padding = cc.p(
            this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL ? sidePadding : cornerPadding,
            this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL ? cornerPadding : sidePadding
        );
        this.setPositionFromCorner(padding);
        this.onScrolled(this.scroll.scrollHandler.getHowMuchOutOfBoundary());
    },

    onScrolled: function (outOfBoundary) {
        if (this._autoHideEnabled) {
            this._autoHideRemainingTime = this.autoHideTime;
            cc.Node.prototype.setOpacity.call(this, this.opacity);
        }

        const innerContainer = this.scroll.getInnerContainer();

        let innerContainerMeasure = 0;
        let scrollViewMeasure = 0;
        let scrollRange = 0;
        let outOfBoundaryValue = 0;
        let innerContainerPosition = 0;

        if (this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL) {
            innerContainerMeasure = innerContainer.height;
            scrollViewMeasure = this.scroll.height;
            scrollRange = this.scroll.max.y - this.scroll.min.y;
            outOfBoundaryValue = outOfBoundary.y;
            innerContainerPosition = -innerContainer.getPositionY() + scrollRange / 2;
        } else if (this.dir === cleverapps.UI.ScrollView.DIR_HORIZONTAL) {
            innerContainerMeasure = innerContainer.width;
            scrollViewMeasure = this.scroll.width;
            scrollRange = this.scroll.max.x - this.scroll.min.x;
            outOfBoundaryValue = outOfBoundary.x;
            innerContainerPosition = -innerContainer.getPositionX() + scrollRange / 2;
        }

        const length = this._calculateLength(innerContainerMeasure, scrollViewMeasure, outOfBoundaryValue);
        const position = this._calculatePosition(scrollRange, scrollViewMeasure, innerContainerPosition, outOfBoundaryValue, length);
        this._updateLength(length);
        this.setPosition(position);
    },

    getActualContentSize: function () {
        return this.bar.getContentSize();
    },

    // The bar follows the pointer's absolute position: accumulating per-move deltas drifts and loses movement past the ends.
    addControls: function () {
        cleverapps.UI.onDrag(this.bar, {
            instantDrag: true,

            onDragStart: function (touch) {
                this.scroll.scrollHandler.stopAutoScroll();
                this.grabOffset = this.getTrackPosition(this.parent.convertToNodeSpace(touch.getLocation())) - this.getTrackPosition(this.getPosition());
                return true;
            }.bind(this),

            onDragMoveNotThrottled: function (touch) {
                const pointer = this.getTrackPosition(this.parent.convertToNodeSpace(touch.getLocation()));
                this.scroll.scrollToPercent(this.getPosToPercent(pointer - this.grabOffset), undefined, this.dir);
            }.bind(this)
        });
    },

    getTrackPosition: function (point) {
        return this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL ? point.y : point.x;
    },

    // pos is the bar's start along the track, in the bar container's space.
    getPosToPercent: function (pos) {
        const corner = this.getTrackPosition(this.getPositionFromCorner());
        const scrollMeasure = this.dir === cleverapps.UI.ScrollView.DIR_VERTICAL ? this.scroll.height : this.scroll.width;
        const range = scrollMeasure - corner * 2 - this.getActualContentSize().height;
        return (pos - corner) / range * 100;
    }
});

Object.defineProperty(ScrollBar.prototype, "opacity", {
    get: function () {
        return this.getOpacity();
    },
    set: function (opacity) {
        this.setOpacity(opacity);
    }
});

cleverapps.styles.ScrollBar = {
    barWidth: 12,
    cornerPadding: 20,
    sidePadding: 20
};

ScrollBar.DEFAULT_COLOR = new cc.Color(52, 65, 87);
ScrollBar.DEFAULT_MARGIN = 20;
ScrollBar.DEFAULT_AUTO_HIDE_TIME = 0.2;
ScrollBar.DEFAULT_SCROLLBAR_OPACITY = 0.4;
ScrollBar.BASE_WIDTH = 12;